/* istanbul ignore file */
import React from 'react';
import { Dropdown, DefaultDropdownProps } from 'framework/form';
import { LEAD_SOURCE } from 'domain/sales/lead/shared/leadService';

const LeadSourceDropdown = (props: Omit<DefaultDropdownProps, 'options'>) => {
  return (
    <Dropdown
      placeholder="Choose lead source"
      options={Object.entries(LEAD_SOURCE).map(entry => {
        const [value, label] = entry;
        return {
          value,
          label,
        };
      })}
      label="Lead source"
      {...props}
    />
  );
};

export default LeadSourceDropdown;
